import { ReactNode } from "react";

type InfoScreenProps = {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
};

// Full-screen, centered message used for auth/error/empty states (sign-out,
// auth error, expired clip). Pass the body text and any action as children.
export default function InfoScreen({ icon, title, children }: InfoScreenProps) {
  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center">
        <div className="flex justify-center mb-4">{icon}</div>
        <h1 className="text-2xl font-bold mb-2">{title}</h1>
        {children}
      </div>
    </div>
  );
}
